import { getOperationalCapabilities } from "@/features/auth/operationalCapabilities";
import { useCurrentUser } from "@/features/auth/useCurrentUser";
import { useSearch } from "@tanstack/react-router";
import { ClientQuotationPage } from "./ClientQuotationPage";
import { QuotationHistoryPage } from "./QuotationHistoryPage";

export function CotacaoPage() {
  const search = useSearch({ from: "/_auth/cotacoes" });
  const { data: currentUser } = useCurrentUser();
  const { canDelete, canManageQuotation } =
    getOperationalCapabilities(currentUser);

  if (!currentUser) return null;
  return canManageQuotation ? (
    <QuotationHistoryPage canDelete={canDelete} />
  ) : (
    <ClientQuotationPage
      currentUser={currentUser}
      editOrderId={search.editOrderId}
      dashboardLink={
        search.date && (search.storeId || search.clientId) && search.quotationId
          ? {
              date: search.date,
              storeId: search.storeId,
              clientId: search.clientId,
              quotationId: search.quotationId,
              itemId: search.itemId,
            }
          : undefined
      }
    />
  );
}
